//
// FillPatternAttributes.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AttributesModel";
import "@sas-dvr/ltjs-commons/styles/FillPattern";
import "@sas-dvr/ltjs-commons/models/attributes/FillPatternAttributesInterface";

var FillPatternAttributes = createModule("gtl::FillPatternAttributes", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::AttributesModel"], EventDispatcher, [
    ,
    {
        fillPattern: 4,
        fillPatternColor: 10,
        transparency: 5,
    },
    ,
    ,
    {
        copyFromBundle: [0,1],
        setStyle: [0,1],
        setStyleElement: [0,4],
        copyFrom: [0,1],
        setStyleElementChain: [0,[4]],
        asFillPatternAttributesInterface: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default FillPatternAttributes;
